<template>
  <section
    class="contacts-banner elevation-1 overflow-hidden mb-4"
    :class="{
      'rounded-sm pa-6': !isMobile,
      'contacts-banner--mobile px-4 py-8': isMobile,
    }"
    data-qa="contacts-banner"
  >
    <div class="position-relative text-subtitle-1 bg-gray-0--text">
      <!-- eslint-disable max-len -->
      {{ t('Наша политика - открытость и клиентоориентированность. Пожалуйста, свяжитесь с нами любым удобным способом. Будем рады оказаться полезными!', options) }}
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import { useContextStore } from 'src/store'
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()

const isMobile = computed(() => context?.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.contacts-banner {
  position: relative;
  background: url('/static/_v1/pd/banners/contacts-banner.jpeg') no-repeat center -170px / cover;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(#363636, .6);
  }

  &--mobile {
    background-position-y: -25px;
  }
}
</style>
